import { createTranslationFile, createLanguage } from "@vocab/core/runtime";
const translations = createTranslationFile({
  en: createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  th: createLanguage({
    Australia: "ออสเตรเลีย",
    "Hong Kong": "ฮ่องกง",
    Indonesia: "อินโดนีเซีย",
    Malaysia: "มาเลเซีย",
    "New Zealand": "นิวซีแลนด์",
    Philippines: "ฟิลิปปินส์",
    Singapore: "สิงคโปร์",
    Thailand: "ประเทศไทย"
  }),
  id: createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "Selandia Baru",
    Philippines: "Filipina",
    Singapore: "Singapura",
    Thailand: "Thailand"
  }),
  zh: createLanguage({
    Australia: "澳洲",
    "Hong Kong": "香港",
    Indonesia: "印尼",
    Malaysia: "馬來西亞",
    "New Zealand": "紐西蘭",
    Philippines: "菲律賓",
    Singapore: "新加坡",
    Thailand: "泰國"
  }),
  "en-AU": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  "en-HK": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  "en-ID": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  "en-MY": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  "en-NZ": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  "en-PH": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  "en-SG": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  "en-TH": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "New Zealand",
    Philippines: "Philippines",
    Singapore: "Singapore",
    Thailand: "Thailand"
  }),
  "th-TH": createLanguage({
    Australia: "ออสเตรเลีย",
    "Hong Kong": "ฮ่องกง",
    Indonesia: "อินโดนีเซีย",
    Malaysia: "มาเลเซีย",
    "New Zealand": "นิวซีแลนด์",
    Philippines: "ฟิลิปปินส์",
    Singapore: "สิงคโปร์",
    Thailand: "ประเทศไทย"
  }),
  "id-ID": createLanguage({
    Australia: "Australia",
    "Hong Kong": "Hong Kong",
    Indonesia: "Indonesia",
    Malaysia: "Malaysia",
    "New Zealand": "Selandia Baru",
    Philippines: "Filipina",
    Singapore: "Singapura",
    Thailand: "Thailand"
  }),
  "zh-HK": createLanguage({
    Australia: "澳洲",
    "Hong Kong": "香港",
    Indonesia: "印尼",
    Malaysia: "馬來西亞",
    "New Zealand": "紐西蘭",
    Philippines: "菲律賓",
    Singapore: "新加坡",
    Thailand: "泰國"
  }),
  "en-PSEUDO": createLanguage({
    Australia: "[Ậǚǚšṯřăăƚììăă]",
    "Hong Kong": "[Ḩöööกี้ģ Ḱöööกี้ģ]",
    Indonesia: "[Ïกี้ƌööกี้ẽẽšììăă]",
    Malaysia: "[Ṃăăƚăăýýšììăă]",
    "New Zealand": "[Ñẽẽẽŵ Ƶẽẽẽăăăƚăăăกี้ƌ]",
    Philippines: "[Ƥḩìììƚìììƥƥìììกี้ẽẽẽš]",
    Singapore: "[Šììกี้ģăăƥööřẽẽ]",
    Thailand: "[Ṯḩăăăìììƚăăăกี้ƌ]"
  })
});
export {
  translations
};
